import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=04bd3572&scoped=true"
import script from "./navbar.component.ts?vue&type=script&lang=ts&external"
export * from "./navbar.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd3572",
  null
  
)

export default component.exports